<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  mounted() {
    window.addEventListener('unload', function(event) {
        window.localStorage.removeItem('goods');
    });
  },
  beforeUnmount() {
    window.removeEventListener('unload', function(event) {
        window.localStorage.removeItem('goods');
    });
  },
  methods: {
    handleUnload() {
      window.localStorage.removeItem('goods');
    },
  }
}
</script>
<style>
#app {
  font-family: "\5FAE\8F6F\96C5\9ED1";
}

html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
}

:root {
  --main-width: 1200px;
  --title-top: 40px;
  --fontSize: 13px;
}

.shipping-tooltip {
  width: 480px !important;
  max-width: 480px !important;
  font-size: 14px;
  line-height: 20px;
}

.upload-section {
  width: max-content !important;
}

.required {
  color: red;
}

.origin {
  position: relative;
  padding-left: 15px;
  font-size: 15px;
  margin-bottom: 5px;
}

.origin::before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #1757B1;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.text-container {
  font-size: 15px;
  margin-bottom: 5px;
}

.origin-text {
  position: relative;
  padding-left: 15px;
  font-size: 14px;
  line-height: 1.5;

}

.origin-text::before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #1757B1;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 6px;
}
</style>
